export default {
    'ERROR-GET-MEMBERS-ADMIN': {
    // No custom error thrown during fetching team members, nothing to map here
    },
    'ERROR-CREATE-MEMBER-ADMIN': {
        'TEAMSPACE-IDS-REQUIRED': {
            actionType: 'toast',
            message: {
                fr: "Veuillez sélectionner au moins un teamspace.",
                en: "Please select at least one teamspace.",
            },
        },
        'USER-ALREADY-EXISTS': {
            actionType: 'toast',
            message: {
                fr: "Un membre avec cet email existe déjà.",
                en: "A member with this email already exists.",
            },
        },
        'TEAMSPACE-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Teamspace introuvable.",
                en: "Teamspace not found.",
            },
        },
    },
    'ERROR-UPDATE-MEMBER-ADMIN': {
        'USER-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Utilisateur introuvable.",
                en: "User not found.",
            },
            redirectPath: '/settings/settings-information/team',
        },
        'NO-FIELDS-TO-UPDATE': {
            actionType: 'toast',
            message: {
                fr: "Aucun champ à mettre à jour.",
                en: "No fields to update.",
            },
        },
        'ROLE-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Rôle introuvable.",
                en: "Role not found.",
            },
        },
        'NO-USER-ROLES-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Aucun rôle utilisateur trouvé.",
                en: "No user roles found.",
            },
        },
    },
    'ERROR-UPLOAD-MEMBER-PICTURE': {
        'FILE-INCOMPLETE': {
            actionType: 'toast',
            message: {
                fr: "Fichier incomplet. Veuillez réessayer.",
                en: "Incomplete file. Please try again.",
            },
        },
        'USER-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Utilisateur introuvable.",
                en: "User not found.",
            },
            redirectPath: '/settings/settings-information/team',
        },
        'NO-FILE-TO-UPLOAD': {
            actionType: 'toast',
            message: {
                fr: "Aucun fichier à télécharger.",
                en: "No file to upload.",
            },
        },
        'NO-PROFILE-PICTURE-URLS-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Échec du téléchargement de l'image de profil.",
                en: "Failed to upload profile picture.",
            },
        },
    },
};
